var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('base-heading',{attrs:{"id":"playground"}},[_vm._v("Generic.Pages.playground")]),_c('example',{attrs:{"id":("usage-" + (-1)),"value":_vm.internalValue,"namespace":_vm.namespace,"page":_vm.page}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }